'use es6';

import { IMAGE, TEXT, FONT } from 'DesignData/enums/RawAssetTypes';
/**
 * Updating these exports requires updates to DesignEditorsUI en.lyaml
 * DesignEditorsUI.rawAssetEditor.sidebar.nameLabel.typeLabel
 */

export const png = Object.freeze({
  name: 'PNG',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const PNG = png;
export const jpg = Object.freeze({
  name: 'JPG',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const JPG = jpg;
export const jpeg = Object.freeze({
  name: 'JPEG',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const JPEG = jpeg;
export const gif = Object.freeze({
  name: 'GIF',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const GIF = gif;
export const tif = Object.freeze({
  name: 'TIF',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const TIF = tif;
export const svg = Object.freeze({
  name: 'SVG',
  type: IMAGE,
  mode: undefined,
  editable: true
});
export const SVG = svg;
/* Text Based Raw Assets */

export const txt = Object.freeze({
  name: 'TXT',
  type: TEXT,
  mode: 'text/plain',
  editable: true
});
export const TXT = txt;
export const css = Object.freeze({
  name: 'CSS',
  type: TEXT,
  mode: 'text/css',
  editable: true
});
export const CSS = css;
export const js = Object.freeze({
  name: 'JS',
  type: TEXT,
  mode: 'text/javascript',
  editable: true
});
export const JS = js;
export const json = Object.freeze({
  name: 'JSON',
  type: TEXT,
  mode: 'application/json',
  editable: true
});
export const JSON = json;
export const md = Object.freeze({
  name: 'MD',
  type: TEXT,
  mode: 'text/x-markdown',
  editable: true
});
export const MD = md;
export const map = Object.freeze({
  name: 'MAP',
  type: TEXT,
  mode: 'application/json',
  editable: true
});
export const MAP = map;
export const graphql = Object.freeze({
  name: 'GRAPHQL',
  type: TEXT,
  mode: 'graphql',
  editable: true
});
export const GRAPHQL = graphql;
/* Font Raw Assets */

export const ttf = Object.freeze({
  name: 'TTF',
  type: FONT,
  mode: undefined,
  editable: false
});
export const TTF = ttf;
export const woff = Object.freeze({
  name: 'WOFF',
  type: FONT,
  mode: undefined,
  editable: false
});
export const WOFF = woff;
export const woff2 = Object.freeze({
  name: 'WOFF2',
  type: FONT,
  mode: undefined,
  editable: false
});
export const WOFF2 = woff2;